module.exports = __webpack_public_path__ + "img/solution1.ae783f32.png";